export default __webpack_public_path__ + "static/media/das.531a0133.png";